<div class="rds-c-viewport-container">
  <table
    aria-label="Data dictionary"
    i18n-aria-label
    mat-table
    cdkDropListGroup
    [cdkDropListGroupDisabled]="!resizableColumns"
    [dataSource]="variables"
    [ngClass]="{
      'mtna-ghost-table': loading,
      'resizable-columns': resizableColumns,
      'resize-active': _resizingColumn,
      editable: editable,
      'mtna-dense-table': editable
    }"
    [trackBy]="'uri' | mtnaTrackByProperty"
  >
    <ng-container
      *ngFor="let col of allColumnOptions; trackBy: 'property' | mtnaTrackByProperty"
      [matColumnDef]="col.property"
      [ngSwitch]="col.property"
    >
      <!-- Selected Column -->
      <ng-template [ngSwitchCase]="'selected'">
        <th mat-header-cell *matHeaderCellDef class="selection-cell">
          <mat-checkbox
            *ngIf="!loading"
            (change)="masterToggle($event)"
            [checked]="variables.length | isSelected: 'all':variables:toggledAreSelected:_toggledUris"
            [indeterminate]="variables.length | isSelected: 'onlySome':variables:toggledAreSelected:_toggledUris"
          >
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let variable" class="selection-cell mtna-ghostable-cell">
          <mat-checkbox
            *ngIf="!loading"
            [attr.aria-label]="variable.name || variable.label || variable.id"
            (click)="$event.stopPropagation()"
            (change)="$event ? toggle.emit({ selected: $event.checked, variable: variable }) : null"
            [checked]="toggledAreSelected ? _toggledUris[variable.uri] : !_toggledUris[variable.uri]"
          >
          </mat-checkbox>
        </td>
      </ng-template>
      <!-- Edit Button Column -->
      <ng-template [ngSwitchCase]="'editButton'">
        <th mat-header-cell *matHeaderCellDef class="edit-cell">
          {{ col.label }}
        </th>
        <td mat-cell *matCellDef="let variable" class="edit-cell mtna-ghostable-cell">
          <button *ngIf="!loading" mat-icon-button tabindex="0" [attr.aria-label]="col.label" (click)="editVariable.emit(variable)">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-template>
      <!-- Has Classification Column -->
      <ng-template [ngSwitchCase]="'hasClassification'">
        <th
          mat-header-cell
          *matHeaderCellDef
          [ngClass]="{ resizing: _resizingColumn && _currentResizeId === col.property }"
          [ngStyle]="{
            'width.px': resizableColumns ? _columnWidth[col.property] : null,
            'min-width.px': resizableColumns ? _columnWidth[col.property] : null,
            'max-width.px': resizableColumns ? _columnWidth[col.property] : null
          }"
          class="check-icon-cell"
        >
          <span
            *ngIf="resizableColumns"
            class="drag-handle"
            (dblclick)="_onAutoResize($event, col.property)"
            (mousedown)="_onResizeColumn($event, col.property)"
          ></span>
          {{ col.label }}
        </th>
        <td
          mat-cell
          *matCellDef="let variable"
          class="check-icon-cell mtna-ghostable-cell"
          [ngStyle]="{
            'width.px': resizableColumns ? _columnWidth[col.property] : null,
            'min-width.px': resizableColumns ? _columnWidth[col.property] : null,
            'max-width.px': resizableColumns ? _columnWidth[col.property] : null
          }"
        >
          <span class="cdk-visually-hidden">{{ variable.classificationUri ? 'True' : 'False' }}</span>
          <mat-icon *ngIf="variable.classificationUri">check_circle</mat-icon>
        </td>
      </ng-template>
      <!-- Is Measure -->
      <ng-template [ngSwitchCase]="'isMeasure'">
        <th
          mat-header-cell
          *matHeaderCellDef
          [ngClass]="{ resizing: _resizingColumn && _currentResizeId === col.property }"
          [ngStyle]="{
            'width.px': resizableColumns ? _columnWidth[col.property] : null,
            'min-width.px': resizableColumns ? _columnWidth[col.property] : null,
            'max-width.px': resizableColumns ? _columnWidth[col.property] : null
          }"
          class="check-icon-cell"
        >
          <span
            *ngIf="resizableColumns"
            class="drag-handle"
            (dblclick)="_onAutoResize($event, col.property)"
            (mousedown)="_onResizeColumn($event, col.property)"
          ></span>
          {{ col.label }}
        </th>
        <td
          mat-cell
          *matCellDef="let variable; let index = index"
          class="check-icon-cell mtna-ghostable-cell"
          [ngStyle]="{
            'width.px': resizableColumns ? _columnWidth[col.property] : null,
            'min-width.px': resizableColumns ? _columnWidth[col.property] : null,
            'max-width.px': resizableColumns ? _columnWidth[col.property] : null
          }"
        >
          <mtna-inline-editor
            [readonly]="editable | uneditable: col.property:uneditableCols"
            (update)="updateCell($event, index, 'isMeasure', variable)"
          >
            <ng-template mtnaViewMode>
              <span class="cdk-visually-hidden">{{ variable.isMeasure ? 'True' : 'False' }}</span>
              <mat-icon *ngIf="variable.isMeasure; else emptyCell">check_circle</mat-icon>
            </ng-template>
            <ng-template mtnaEditMode>
              <mat-checkbox [formControl]="(index | rdsGetFormArrayControl: _formArray:'isMeasure')!" mtnaFocusAfterViewInit></mat-checkbox>
            </ng-template>
          </mtna-inline-editor>
        </td>
      </ng-template>
      <!-- Is Required -->
      <ng-template [ngSwitchCase]="'isRequired'">
        <th
          mat-header-cell
          *matHeaderCellDef
          [ngClass]="{ resizing: _resizingColumn && _currentResizeId === col.property }"
          [ngStyle]="{
            'width.px': resizableColumns ? _columnWidth[col.property] : null,
            'min-width.px': resizableColumns ? _columnWidth[col.property] : null,
            'max-width.px': resizableColumns ? _columnWidth[col.property] : null
          }"
          class="check-icon-cell"
        >
          <span
            *ngIf="resizableColumns"
            class="drag-handle"
            (dblclick)="_onAutoResize($event, col.property)"
            (mousedown)="_onResizeColumn($event, col.property)"
          ></span>
          {{ col.label }}
        </th>
        <td
          mat-cell
          *matCellDef="let variable; let index = index"
          class="check-icon-cell mtna-ghostable-cell"
          [ngStyle]="{
            'width.px': resizableColumns ? _columnWidth[col.property] : null,
            'min-width.px': resizableColumns ? _columnWidth[col.property] : null,
            'max-width.px': resizableColumns ? _columnWidth[col.property] : null
          }"
        >
          <mtna-inline-editor
            [readonly]="editable | uneditable: col.property:uneditableCols"
            (update)="updateCell($event, index, 'isRequired', variable)"
          >
            <ng-template mtnaViewMode>
              <span class="cdk-visually-hidden">{{ variable.isRequired ? 'True' : 'False' }}</span>
              <mat-icon *ngIf="variable.isRequired; else emptyCell">check_circle</mat-icon>
            </ng-template>
            <ng-template mtnaEditMode>
              <mat-checkbox
                [formControl]="(index | rdsGetFormArrayControl: _formArray:'isRequired')!"
                mtnaFocusAfterViewInit
              ></mat-checkbox>
            </ng-template>
          </mtna-inline-editor>
        </td>
      </ng-template>
      <!-- Is Weight -->
      <ng-template [ngSwitchCase]="'isWeight'">
        <th
          mat-header-cell
          *matHeaderCellDef
          [ngClass]="{ resizing: _resizingColumn && _currentResizeId === col.property }"
          [ngStyle]="{
            'width.px': resizableColumns ? _columnWidth[col.property] : null,
            'min-width.px': resizableColumns ? _columnWidth[col.property] : null,
            'max-width.px': resizableColumns ? _columnWidth[col.property] : null
          }"
          class="check-icon-cell"
        >
          <span
            *ngIf="resizableColumns"
            class="drag-handle"
            (dblclick)="_onAutoResize($event, col.property)"
            (mousedown)="_onResizeColumn($event, col.property)"
          ></span>
          {{ col.label }}
        </th>
        <td
          mat-cell
          *matCellDef="let variable; let index = index"
          class="check-icon-cell mtna-ghostable-cell"
          [ngStyle]="{
            'width.px': resizableColumns ? _columnWidth[col.property] : null,
            'min-width.px': resizableColumns ? _columnWidth[col.property] : null,
            'max-width.px': resizableColumns ? _columnWidth[col.property] : null
          }"
        >
          <mtna-inline-editor
            [readonly]="editable | uneditable: col.property:uneditableCols"
            (update)="updateCell($event, index, 'isWeight', variable)"
          >
            <ng-template mtnaViewMode>
              <span class="cdk-visually-hidden">{{ variable.isWeight ? 'True' : 'False' }}</span>
              <mat-icon *ngIf="variable.isWeight; else emptyCell">check_circle</mat-icon>
            </ng-template>
            <ng-template mtnaEditMode>
              <mat-checkbox [formControl]="(index | rdsGetFormArrayControl: _formArray:'isWeight')!" mtnaFocusAfterViewInit></mat-checkbox>
            </ng-template>
          </mtna-inline-editor>
        </td>
      </ng-template>
      <!-- All other columns -->
      <ng-template ngSwitchDefault>
        <th
          mat-header-cell
          *matHeaderCellDef
          [ngClass]="{ resizing: _resizingColumn && _currentResizeId === col.property }"
          [ngStyle]="{
            'width.px': resizableColumns ? _columnWidth[col.property] : null,
            'min-width.px': resizableColumns ? _columnWidth[col.property] : null,
            'max-width.px': resizableColumns ? _columnWidth[col.property] : null
          }"
        >
          <span
            *ngIf="resizableColumns"
            class="drag-handle"
            (dblclick)="_onAutoResize($event, col.property)"
            (mousedown)="_onResizeColumn($event, col.property)"
          ></span>
          {{ col.label }}
        </th>
        <td
          mat-cell
          *matCellDef="let variable; let index = index"
          class="mtna-ghostable-cell"
          [ngStyle]="{
            'width.px': resizableColumns ? _columnWidth[col.property] : null,
            'min-width.px': resizableColumns ? _columnWidth[col.property] : null,
            'max-width.px': resizableColumns ? _columnWidth[col.property] : null
          }"
        >
          <mtna-inline-editor
            [readonly]="editable | uneditable: col.property:uneditableCols"
            (update)="updateCell($event, index, $any(col.property), variable)"
          >
            <ng-template mtnaViewMode>
              <span class="view-mode-container" [innerHTML]="variable[col.property]"></span>
            </ng-template>
            <ng-template mtnaEditMode>
              <input mtnaFocusAfterViewInit [formControl]="(index | rdsGetFormArrayControl: _formArray:col.property)!" />
            </ng-template>
          </mtna-inline-editor>
        </td>
      </ng-template>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns | filterColumns: editable; sticky: true"></tr>
    <ng-container *ngIf="editable; else nonEditableRow">
      <tr *matRowDef="let variable; columns: displayedColumns | filterColumns: editable" mat-row></tr>
    </ng-container>
    <ng-template #nonEditableRow>
      <tr
        *matRowDef="let variable; columns: displayedColumns | filterColumns: editable"
        mat-row
        [attr.tabindex]="disableViewDetails ? undefined : 0"
        (click)="handleRowSelection(variable)"
        (keydown)="handleRowKeydown($event, variable)"
      ></tr>
    </ng-template>
  </table>
</div>

<ng-template #emptyCell><span class="view-mode-container"></span></ng-template>
